import React from "react";
import styled from "styled-components";

import { LockIcon } from "assets/icons";

const View = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: ${(p) => p.theme.bgApp};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 24px 32px;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
  background-color: ${(p) => p.theme.bgHighestContrast};

  svg {
    color: var(--grey);
    height: 80px;
    width: auto;
  }
`;

const Text = styled.p`
  max-width: 500px;
  text-align: center;
`;

export const NoPermissionsView = () => {
  return (
    <View>
      <Wrapper>
        <LockIcon />
        <Text>
          <h3>Access restricted</h3>
          You don't have permission to view this page. If this is not desired behavior please
          contact DevSkiller for further assistance, or switch account.
        </Text>
      </Wrapper>
    </View>
  );
};
